import { connectString } from '../helpers/utils';

/**
 * Transform token from oauth2
 * @param {Object} tokens
 * @returns {Object}
 */
export const transformMe = (input = {}) => {
	return {
		object: input.object,
		id: input.id,
		email: input.email,
		name: connectString(input.first_name, input.last_name)(' '),
		first_name: input.first_name,
		last_name: input.last_name,
		phone_number: input.phone_number,
		role: input.role,
		is_active: input.is_active,
		updated_at: input.updated_at,
		created_at: input.created_at,
		password_changed_at: input.password_changed_at,
	};
};